import { BackgroundTransformer } from '@/src/processor'

export type BackgroundPipeline = 'processor' | 'capture-stream'

/**
 * Выбирает путь обработки фона камеры.
 * Обычный путь — вставка процессора в отправляемый трек.
 * Обходной путь — отрисовка на канвас и подмена трека через captureStream.
 * Решение принимается комбинацией признаков: сначала фиче-детект API,
 * дополнительно эвристика по userAgent. Firefox всегда идёт обходным путём,
 * потому что нужных потоковых API там нет.
 */
export function detectBackgroundPipeline(): BackgroundPipeline {
  const hasProcessorApis =
    typeof MediaStreamTrackProcessor !== 'undefined' &&
    typeof MediaStreamTrackGenerator !== 'undefined'
  const isFirefox =
    typeof navigator !== 'undefined' && /firefox\/\d+/i.test(navigator.userAgent)
  if (hasProcessorApis && !isFirefox) {
    return 'processor'
  }
  return 'capture-stream'
}

/**
 * Панель эффектов доступна везде, где живёт сам трансформер (нужен OffscreenCanvas).
 * Обходной путь захвата работает на обычном DOM-канвасе, поэтому отдельного гейта не требует.
 */
export function isBackgroundEffectAvailable(): boolean {
  return BackgroundTransformer.isSupported
}
